import i18n from '../../../../locales/index'
import ABackTop from './index.vue'
export default ABackTop
